export class Config {

    public id: string = "0";
    public name: string;
    public format: string; // html, text 
    public plain_text: string;
    public plain_text_en: string;
    public html_text: string;
    public html_text_en: string;
    
    constructor() {}
    
} 